var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "1031 225 18.057 16.83",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout_icon",
    "data-name": "logout icon",
    transform: "translate(1031.001 225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_577850_cc",
    "data-name": "noun 577850 cc"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8441",
    "data-name": "Path 8441",
    className: "cls-1",
    d: "M11.94,10.33a.42.42,0,0,0-.41.44v3.89a1.12,1.12,0,0,1-1.08,1.16H2a1.12,1.12,0,0,1-1-1.17V2.18A1.12,1.12,0,0,1,2,1h8.4a1.12,1.12,0,0,1,1.08,1.16V6a.41.41,0,0,0,.82,0h0V2.18a2,2,0,0,0-1.9-2H2a2,2,0,0,0-1.9,2V14.65a2,2,0,0,0,1.9,2h8.4a2,2,0,0,0,1.9-2V10.76a.42.42,0,0,0-.36-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8442",
    "data-name": "Path 8442",
    className: "cls-1",
    d: "M2,16.83a2.13,2.13,0,0,1-2-2.19V2.18A2.12,2.12,0,0,1,2,0h8.4a2.13,2.13,0,0,1,2,2.19V6a.31.31,0,0,1,0,.05.547.547,0,0,1-.58.52A.56.56,0,0,1,11.38,6V2.18a1,1,0,0,0-.93-1H2a1,1,0,0,0-.93,1V14.65a1,1,0,0,0,.94,1h8.4a1,1,0,0,0,.93-1V10.76a.57.57,0,0,1,.55-.59h0a.58.58,0,0,1,.55.59v3.88a2.12,2.12,0,0,1-2,2.18ZM10.44.3H2A1.82,1.82,0,0,0,.3,2.18V14.65a1.83,1.83,0,0,0,1.76,1.88h8.4a1.82,1.82,0,0,0,1.75-1.88V10.76a.28.28,0,0,0-.26-.29.27.27,0,0,0-.26.28v3.89A1.27,1.27,0,0,1,10.45,16H2A1.28,1.28,0,0,1,.82,14.64V2.18A1.27,1.27,0,0,1,2,.88h8.41a1.28,1.28,0,0,1,1.23,1.31V6a.257.257,0,0,0,.25.27.24.24,0,0,0,.19-.07.26.26,0,0,0,.11-.2V2.18A1.82,1.82,0,0,0,10.44.3Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "back_arrow",
    "data-name": "back arrow"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12942",
    "data-name": "Group 12942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7797",
    "data-name": "Rectangle 7797"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8443",
    "data-name": "Path 8443",
    className: "cls-1",
    d: "M17.89,8.78l-3.1,3.1a.53.53,0,0,1-.74,0h0a.53.53,0,0,1,0-.74L17.14,8a.53.53,0,0,1,.74,0h0a.53.53,0,0,1,.01.78Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7798",
    "data-name": "Rectangle 7798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8444",
    "data-name": "Path 8444",
    className: "cls-1",
    d: "M14.79,4.94,17.89,8a.53.53,0,0,1,0,.74h0a.53.53,0,0,1-.74,0L14,5.68a.53.53,0,0,1,0-.74h0a.53.53,0,0,1,.79,0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7799",
    "data-name": "Rectangle 7799"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8445",
    "data-name": "Path 8445",
    className: "cls-1",
    d: "M17.14,8.95H5.68a.53.53,0,0,1-.53-.53h0a.53.53,0,0,1,.53-.53H17.14a.53.53,0,0,1,.53.53h0A.53.53,0,0,1,17.14,8.95Z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.5e48960c.svg";
export { ForwardRef as ReactComponent };